// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img.icon {
  display: block;
  height: 100px;
  margin: 0px;
  padding: 0px;
  width: 100px;
}

.magnifying-glass {
  padding: 0px;
  border: none;
  background: none;
  display: block;
  margin-left: 1rem;
}

/* file size: 1.1ko | optimized file size: 0.9ko | base64 size: 1.3ko */
.magnifying-glass svg {
  display: block;
  fill: #009ce6;
  height: 42px;
  width: 42px;
}

.circle-question {
  padding: 4px;
  border: 2px;
  background-color: #1eabe3;
  height: 50px;
  border-radius: 50%;
  width: 50px;
}

#peopleGroupTable .circle-question {
  margin-top: 25px;
  margin-right: 15px;
  z-index: 1;
}

#video-icon {
  display: block;
  margin-left: -2.5px;
  margin-top: -2.5px;
  width: 47px;
  background-color: #ffffff;
  clip-path: circle(45%);
}

.reprocess-icon-animate {
  animation-name: processing;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  transform-origin: 50% 50%;
  display: inline-block;
}
@keyframes processing {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/icons.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,uEAAuE;AACvE;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,mCAAmC;EACnC,iCAAiC;EACjC,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["img.icon {\n  display: block;\n  height: 100px;\n  margin: 0px;\n  padding: 0px;\n  width: 100px;\n}\n\n.magnifying-glass {\n  padding: 0px;\n  border: none;\n  background: none;\n  display: block;\n  margin-left: 1rem;\n}\n\n/* file size: 1.1ko | optimized file size: 0.9ko | base64 size: 1.3ko */\n.magnifying-glass svg {\n  display: block;\n  fill: #009ce6;\n  height: 42px;\n  width: 42px;\n}\n\n.circle-question {\n  padding: 4px;\n  border: 2px;\n  background-color: #1eabe3;\n  height: 50px;\n  border-radius: 50%;\n  width: 50px;\n}\n\n#peopleGroupTable .circle-question {\n  margin-top: 25px;\n  margin-right: 15px;\n  z-index: 1;\n}\n\n#video-icon {\n  display: block;\n  margin-left: -2.5px;\n  margin-top: -2.5px;\n  width: 47px;\n  background-color: #ffffff;\n  clip-path: circle(45%);\n}\n\n.reprocess-icon-animate {\n  animation-name: processing;\n  animation-duration: 1s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  transform-origin: 50% 50%;\n  display: inline-block;\n}\n@keyframes processing {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
